export default __webpack_public_path__ + "static/Pre-job discussions-f93dd610e87c9753b9fb843252670cb1.jpg";